import { h, render, Component } from 'preact';
import Marker from './marker/marker';
import './markers-list.scss';

export default class MarkersList extends Component {
    render(props, state) {
        return (
            <div class="markers-list-wrapper-m">
                <div class="markers-list-m">
                    {
                        props.markers.map( (marker, key) => {
                            return (
                                <Marker marker={marker}
                                    active={props.activeKey == marker.id}
                                    key={marker.id} 
                                    onTapMarker={props.onTapMarker}/>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}